// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_lzB","cls2":"PodcastPlayer-cls2_vf0 PodcastPlayer-cls1_lzB"};